// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"cfd8f164","845":"ee66a780"}[chunkId] + ".chunk.js";
};